import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

//API 
import perfil_api from '../../../../api/perfil_api';

//Helpers
import { showMessage } from '../../../../helpers/message';

//Context 
import { useAuth } from '../../../../context/auth';

//Componentes
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import PerfilStepper from './components/PerfilStepper';

export default function Perfis({ permissoes }) {
    const { setLoading } = useAuth();

    //variavel de edição dos campos
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    //State para pegar os perfil dos usuarios
    const [listPerfil, setListPerfil] = useState([]);

    //State para Editar o perfil dos usuario
    const [perfil_id, setPerfil_id] = useState(null);

    //State para pegar os perfil dos usuario
    const [perfilNovo, setPerfilNovo] = useState(false);

    //Fução para editar perfil
    const editarPerfil = (perfil) => {
        setPerfil_id(perfil.id);
    }

    //Ações que a tabela
    const actions = [
        editavel ?
            actionsTable.editar(editarPerfil)
            : actionsTable.visualizar(editarPerfil)
    ];

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        { value: "Status", objectValue: "status", align: "left" }
    ];

    //Função que carrega a lista de perfis
    const loadPerfil = () => {
        setLoading(true);
        perfil_api.getList().then(response => {
            setListPerfil(response.data);
        })
            .catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    useEffect(() => {
        loadPerfil();
    }, []);

    const handleVoltar = () => {
        setPerfil_id(null);
        setPerfilNovo(false);
        loadPerfil();
    }

    if (perfilNovo || perfil_id) {
        return <PerfilStepper
            id={perfil_id}
            handleVoltar={handleVoltar}
            editavel={editavel}
        />
    }

    return <>
        <div className='d-flex align-items-center justify-content-between mb-4'>
            <h4 className='text-secondary m-0'>Perfil</h4>
            {editavel &&
                <Button color='success' onClick={() => { setPerfilNovo(true) }}>+ Cadastrar</Button>
            }
        </div >
        <TabelaListagem
            actions={actions}
            title={"Lista de Perfil"}
            options={{ print: false, search: true, pagination: true }}
            headers={headers}
            items={listPerfil}
        />
    </>
}